import { buildCreateContext } from './buildCreateContext';
const contextManager = new Map();
export const runWithContext = callback => callback();
export const isRunningWithContext = () => true;
export const createContext = buildCreateContext(() => contextManager);
